import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ReportsNavigation.css';

const ReportsNavigation: React.FC = () => {
  const navigate = useNavigate();

  const reports = [
    {
      id: 'headcount',
      code: 'RPT-EMP-01',
      title: 'Headcount by Department',
      description: 'View active/inactive headcount and new joiners by department',
      icon: '👥',
      path: '/reports/headcount',
    },
    {
      id: 'leave-summary',
      code: 'RPT-LEAVE-01',
      title: 'Leave Summary by Employee',
      description: 'View paid/unpaid leave days, late submissions, and leave balances',
      icon: '📅',
      path: '/reports/leave-summary',
    },
    {
      id: 'late-summary',
      code: 'RPT-LATE-01',
      title: 'Late/Early Summary',
      description: 'View approved minutes, quota usage, and over-quota statistics',
      icon: '⏰',
      path: '/reports/late-summary',
    },
    {
      id: 'approval-sla',
      code: 'RPT-APP-01',
      title: 'Approval SLA Report',
      description: 'View pending approvals, overdue requests, and average decision times',
      icon: '✅',
      path: '/reports/approval-sla',
    },
  ];

  return (
    <div className="reports-navigation">
      <div className="reports-header">
        <h1>Reports & Analytics</h1>
        <p>Generate comprehensive reports for HR and management</p>
      </div>

      <div className="reports-grid">
        {reports.map((report) => (
          <div
            key={report.id}
            className="report-card"
            onClick={() => navigate(report.path)}
          >
            <div className="report-icon">{report.icon}</div>
            <div className="report-content">
              <div className="report-code">{report.code}</div>
              <h3 className="report-title">{report.title}</h3>
              <p className="report-description">{report.description}</p>
            </div>
            <div className="report-arrow">→</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportsNavigation;
